export const getLogEntryMessage = (error: string | Error) => {
  return error instanceof Error ? error.message : error;
};
